import { render } from "./Shipyards.vue?vue&type=template&id=45bdd87e&scoped=true"
import script from "./Shipyards.vue?vue&type=script&lang=ts"
export * from "./Shipyards.vue?vue&type=script&lang=ts"

import "./Shipyards.vue?vue&type=style&index=0&id=45bdd87e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45bdd87e"

export default script